"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var vdl_prefix_1 = require("../util/vdl-prefix");
var caret_left_1 = require("adp-react-icons/lib/fa/caret-left");
var _1 = require("../util/_");
var SidebarItem = /** @class */ (function (_super) {
    __extends(SidebarItem, _super);
    function SidebarItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var onSelect = _this.props.onSelect;
            if (onSelect) {
                onSelect();
            }
        };
        return _this;
    }
    SidebarItem.prototype.render = function () {
        var _a = this.props, active = _a.active, icon = _a.icon, label = _a.label;
        var sidebarItemClasses = (_b = {},
            _b[vdl_prefix_1.vdlPrefix('sidebar-item')] = true,
            _b[vdl_prefix_1.vdlPrefix('sidebar-item--active')] = active,
            _b);
        var customProps = _1.omit(this.props, Object.keys(SidebarItem.propTypes));
        return (React.createElement("li", __assign({}, customProps, { className: classnames_1.classNames(sidebarItemClasses) }),
            React.createElement("a", { className: vdl_prefix_1.vdlPrefix('sidebar-item__container'), onClick: this.handleClick },
                React.createElement("span", { className: vdl_prefix_1.vdlPrefix('sidebar-item__icon') }, icon),
                React.createElement("span", { className: vdl_prefix_1.vdlPrefix('sidebar-item__label') }, label),
                active && React.createElement(caret_left_1.default, { className: vdl_prefix_1.vdlPrefix('sidebar-item__active-indicator') }))));
        var _b;
    };
    SidebarItem.propTypes = {
        label: PropTypes.node.isRequired,
        icon: PropTypes.node.isRequired,
        active: PropTypes.bool,
        onSelect: PropTypes.func.isRequired,
        className: PropTypes.string
    };
    return SidebarItem;
}(React.PureComponent));
exports.SidebarItem = SidebarItem;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/sidebar/sidebar-item.js
// module id = 594
// module chunks = 0 1 2 3 4 5 6